import { ExternalSearchStore } from '@/stores/ExternalSearchStore';
import { CompatibilitiesStore, CompatibilityStore } from './compatibility';
import { GoogleRecaptchaStore } from './GoogleRecaptchaStore';
import { MixpanelStore } from './MixpanelStore';
import { MyAppsStore } from './myApps';
import { MyReviewsStore } from './myReviews';
import { PagesStore } from './pages';
import { SearchStore } from './search';
import { UserStore } from './user';

export class RootStore {
  compatibilitiesStore: CompatibilitiesStore;

  compatibilityStore: CompatibilityStore;

  userStore: UserStore;

  mixpanelStore: MixpanelStore;

  googleRecaptchaStore: GoogleRecaptchaStore;

  pagesStore: PagesStore;

  searchStore: SearchStore;

  myAppsStore: MyAppsStore;

  externalSearchStore: ExternalSearchStore;

  myReviewsStore: MyReviewsStore;

  constructor() {
    this.compatibilitiesStore = new CompatibilitiesStore(this);
    this.compatibilityStore = new CompatibilityStore(this);
    this.userStore = new UserStore();
    this.mixpanelStore = new MixpanelStore();
    this.googleRecaptchaStore = new GoogleRecaptchaStore();
    this.pagesStore = new PagesStore(this);
    this.searchStore = new SearchStore(this);
    this.myAppsStore = new MyAppsStore(this);
    this.externalSearchStore = new ExternalSearchStore();
    this.myReviewsStore = new MyReviewsStore();
  }
}
